// import 'hammerjs';
import { enableProdMode, LOCALE_ID } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  if (window) {
    // disable console log and warn in production environment.
    // tslint:disable-next-line: only-arrow-functions
    window.console.log = function() { };
    // tslint:disable-next-line: only-arrow-functions
    window.console.warn = function() { };
  }
}

platformBrowserDynamic().bootstrapModule(AppModule, {
  providers: [{provide: LOCALE_ID, useValue: 'en-US' }]
})
  .catch(err => console.error(err));
